import * as React from "react";
const SvgMinimizer = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.1 19.333v-4.434H.667v-2H7.1v6.434h-2Zm7.8 0v-6.434h6.433v2H14.9v4.434h-2ZM.667 7.099v-2H5.1V.666h2v6.433H.667Zm12.233 0V.666h2v4.433h4.433v2H12.9Z"
      fill={props?.fill || "#091E42"}
    />
  </svg>
);
export default SvgMinimizer;
